<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import {BrandsPath} from "../../../../path";
import add from "./add.vue";
/* Dashboard component */
export default {
  components: {
    Layout,
    PageHeader,
    add : add
  },
  data() {
    return {
      title: "Brands",
      items: [
        {
          text: "List",
        },
        {
          text: "Brand",
          active: true,
        },
      ],
      selectedBrand : {},
      brands : [],
      base_url : process.env.VUE_APP_API_BACKEND_URL,
      filter : [],
      fields : ["name","description","Actions"],
      currentPage : 1
    };
  },
  watch : {
    currentPage(){
      this.getBrands();
    }
  },
  methods : {
    async getBrands(){
      try {
        let response = await axios.get(this.base_url + BrandsPath.BASIC_BRAND,{
          params :{
            page : this.currentPage
          }
        });
        if(response.data.status == true){
          this.brands = response.data.data;
        }
      }catch (e){
        console.log(e);
      }
    },
    reload(){
      this.getBrands();
    },
    setEdit(d){
      this.selectedBrand = d;
      this.$bvModal.show('bv-add-brand');
    },
    async deleteData(d){
      try {
        let response = await axios.delete(this.base_url + BrandsPath.BASIC_BRAND + '/' + d.id);
        if(response.data.status == true){
          this.$bvToast.toast('Successfully Deleted', {
            title: `Brand Deleted`,
            variant: 'success',
            solid: true
          });
          this.getBrands();
        }
      }catch (e){
        console.log(e);
      }
    }
  },
  mounted() {
    this.getBrands();
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-6">
                <b-button @click="$bvModal.show('bv-add-brand')" class="btn btn-primary mb-10 pb-10">Add Brand</b-button>
                <b-modal id="bv-add-brand" :title="(Object.keys(selectedBrand).length > 0 ? 'Edit' : 'Add') + ' Brand'" hide-footer>
                  <add @update="reload()" :selectedBrand="selectedBrand"></add>
                </b-modal>
              </div>
              <!-- Search -->
<!--              <div class="col-sm-12 col-md-6">-->
<!--                <div id="tickets-table_filter" class="dataTables_filter text-md-right">-->
<!--                  <label class="d-inline-flex align-items-center mr-5">-->
<!--                    Search:-->
<!--                    <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2"></b-form-input>-->
<!--                    &lt;!&ndash; <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2"></b-form-input> &ndash;&gt;-->
<!--                  </label>-->
<!--                </div>-->
<!--              </div>-->

              <!-- End search -->
            </div>
            <div class="table-responsive mb-0">
              <b-table
                  :key="brands.key"
                  :items="brands.data"
                  :fields="fields"
                  responsive="sm"
                  :filter="filter"
                  :current-page="currentPage"
              >
                <template v-slot:cell(actions)="row">
                  <b-button @click="setEdit(row.item)" variant="primary">
                    <i class="fa fa-pen"></i>
                  </b-button>
                  <b-button @click="deleteData(row.item)" variant="danger" class="ml-1">
                    <i class="fa fa-trash"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination :key="brands.key" v-model="currentPage" :total-rows="brands.total" :per-page="brands.per_page"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
